import React from 'react';
import { motion } from 'framer-motion';
import { CaprelsaWordmark } from './CaprelsaWordmark';
import { SnakButton } from './SnakButton';
type AttractSceneProps = {
  onNext: () => void;
  still?: boolean;
};
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/07a0d093-a3c5-44ad-ab93-9afd96bf9a6c.jpg';
export function AttractScene({
  onNext,
  still = false
}: AttractSceneProps) {
  return <div className="flex h-full flex-col" data-id="element-391" data-mp="2kfnrtjxvj7y">
      <div className="flex items-center justify-between" data-id="element-392" data-mp="2jcwvlmm9gs1">
        <CaprelsaWordmark data-id="element-393" data-mp="7jij2ma4ab2q" />
        <span className="rounded-full bg-cap-lilac px-2.5 py-1 text-[9px] font-bold uppercase tracking-[0.16em] text-cap-purple" data-id="element-394" data-mp="7iplaat4yvwq">For HCPs</span>
      </div>

      <div className="relative -mx-6 mt-4 h-[280px] overflow-hidden" data-id="element-395" data-mp="hamvbe8erhtv">
        <motion.img src={HERO_IMAGE} alt="A smiling older man with a healthcare professional's hand on his shoulder" className="h-full w-full object-cover object-[70%_center]" initial={{
        scale: still ? 1 : 1.08
      }} animate={{
        scale: 1
      }} transition={{
        duration: 2.4,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-396" data-mp="lbyqs0dyqx9z" />
        <span className="absolute bottom-3 left-6 text-[10px] font-medium text-white drop-shadow" data-id="element-397" data-mp="3mfz3wc2g257t">Not actual patient</span>
        <div className="absolute inset-x-0 bottom-0 h-1.5 bg-cap-gold" aria-hidden="true" data-id="element-398" data-mp="3hk0k71s29bdq" />
      </div>

      <motion.p initial={{
      opacity: still ? 1 : 0,
      y: still ? 0 : 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3,
      duration: 0.5
    }} className="mt-5 text-[11px] font-bold uppercase tracking-[0.16em] text-cap-gold" data-id="element-399" data-mp="3clfguthiibl2">
        Medullary thyroid cancer
      </motion.p>
      <motion.h1 initial={{
      opacity: still ? 1 : 0,
      y: still ? 0 : 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.45,
      duration: 0.6,
      ease: [0.23, 1, 0.32, 1]
    }} className="mt-1.5 text-[34px] font-extrabold leading-[1.02] tracking-[-0.03em] text-cap-purple" data-id="element-400" data-mp="3vi8bat2f1igz">
        When slowing progression matters.
      </motion.h1>
      <motion.p initial={{
      opacity: still ? 1 : 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.7,
      duration: 0.5
    }} className="mt-3 text-[15px] leading-snug text-cap-grey" data-id="element-401" data-mp="2mb6pwk3uc5cr">
        Aggressive, symptomatic disease keeps moving. Explore one case — and the evidence behind Caprelsa.
      </motion.p>

      <div className="mt-auto pt-5" data-id="element-402" data-mp="22ktmt85ze03h">
        <SnakButton onClick={onNext} data-id="element-403" data-mp="22jjochv7upwb">EXPLORE THE CASE</SnakButton>
      </div>
    </div>;
}